import { render, staticRenderFns } from "./PlantSatgas3.vue?vue&type=template&id=53fe2542"
import script from "./PlantSatgas3.vue?vue&type=script&lang=js"
export * from "./PlantSatgas3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports